// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:44:12+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            83e7d4f678b4bec22d5d717ac5162d4c
//    Signature:      eyJpdiI6Ijg2NUVVRlhoR216bG1QZEFsVXd4bEE9PSIsInZhbHVlIjoiWnhTS2lHa3ArWm15SUh6bkxnNjFiUllITWtOMkw2VDhmQXBzb0N0VGJcL0w5SldOeEFnVFJhWW93dWFyZU9rV0VwTkhBdFZcL0IrNkxWN3RHMTZjV1BxWWdvTW5JalhuUXlIMXc5NGhmNHp4R2sycFV6OTBrdXVkN1RicTRkQmxmZkFlU3YwMmxNVTVPYkZnUUF5bzc1XC9XNmVhOEJzKzNJSjNSRmN4R1RDbmdGaFl2OXJNbGN4ZnFRQVwvV3pDTExnTjM1QlNMNjBNdmErNEsrVytKMk1Qa2tzcUM5c0JqVUlzb0V2WTcrcUJyTWp3U3hoeFVUYTQwaUoreVJOZ0ZNXC9FUk9nYjVGUVNpbk16emhSajU1TTFadnM4aXlnWnY4SGd4Tmw4UVN5akZXdVg3dHpWNm1oa1lQcmFQeUJuK2pwUkkxcnVrM0s0OGUrbVRIamI2cm44T0lcL0xRY3o0c0pjdUVLVzB1K3RRWVY1QVR5V1VMeU54WVB1am5VN3NsdHB6Rlh2UU5lenk3RXhlNTJGMDdIN0h1Zz09IiwibWFjIjoiODU0ZmFiMjQzNmVhYzQyZDgyMTllMWUyNDMyODFjZDJjNTY5MjhlZjRlMDk4OTBiNzFiOTgzYzVkZDM1NTAwZCJ9
class SizeGuideController extends HTMLElement {
  connectedCallback() {
    // Check if this is inside a modal or standalone
    const modal = this.closest('.product-popup-modal');
    const isModal = !!modal;
    
    if (isModal && modal.dataset.sizeGuideSetup === '1') return;

    const content = modal ? modal.querySelector('.product-popup-modal__content-info') : this.parentElement;
    if (!content) return;

    const sizingContainers = content.querySelectorAll('.Container.sizing');
    if (!sizingContainers.length) return;

    // Attach gender/unit interactions for each sizing container
    sizingContainers.forEach(container => {
      this.attachInteractions(container);
    });

    if (isModal) {
      modal.dataset.sizeGuideSetup = '1';
    }
  }

  attachInteractions(container) {
    const womenTab = container.querySelector('.clear-this .half[data-id="women-tab"]');
    const menTab = container.querySelector('.clear-this .half[data-id="men-tab"]');
    const womenSection = container.querySelector('.women');
    const menSection = container.querySelector('.men');

    // Toggle visble gender sections and active tab state
    const showGender = target => {
      if (!womenSection || !menSection) return;
      const showWomen = target === 'women';

      womenSection.style.display = showWomen ? '' : 'none';
      menSection.style.display = showWomen ? 'none' : '';

      if (womenTab) womenTab.classList.toggle('active', showWomen);
      if (menTab) menTab.classList.toggle('active', !showWomen);
  
    };

    // Switch the active unit (CM/INCH) within the current gender
    const activateUnit = (sectionRoot, unitId) => {
      if (!sectionRoot) return;

      const unitTabs = sectionRoot.querySelectorAll('.measurements');
      const unitPanels = sectionRoot.querySelectorAll('.measurement-contents');

      unitTabs.forEach(tab => tab.classList.remove('active'));
      unitPanels.forEach(panel => {
        panel.classList.remove('active');
        panel.style.display = 'none';
      });

      const targetTab = sectionRoot.querySelector(`.measurements[data-id="${unitId}"]`);
      const targetPanel = sectionRoot.querySelector(`.measurement-contents[data-id="${unitId}"]`);

      if (targetTab) targetTab.classList.add('active');
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.style.display = '';
      }
    };

    // Bind gender tab clicks (Women/Men)
    container.querySelectorAll('.clear-this .half').forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-id');
        if (id === 'women-tab') {
          showGender('women');
          activateUnit(womenSection, 'women-cm');
        } else if (id === 'men-tab') {
          showGender('men');
          activateUnit(menSection, 'men-cm');
        }
      });
    });

    [womenSection, menSection].forEach(sectionRoot => {
      if (!sectionRoot) return;
      sectionRoot.querySelectorAll('.measurements').forEach(button => {
        button.addEventListener('click', () => {
          const unitId = button.getAttribute('data-id');
          activateUnit(sectionRoot, unitId);
        });
      });
    });

    container.querySelectorAll('.measurement-contents').forEach(panel => {
      const shouldShow = panel.classList.contains('active');
      panel.style.display = shouldShow ? '' : 'none';
    });

    if (menSection && menTab && !menTab.classList.contains('active')) {
      menSection.style.display = 'none';
    }
  }
}

customElements.define('size-guide-controller', SizeGuideController);

// Watch for the product modal opening, then inject the controller
const observer = new MutationObserver(muts => {
  muts.forEach(m => {
    if (m.type === 'attributes' && m.attributeName === 'open' && m.target.classList && m.target.classList.contains('product-popup-modal')) {
      if (m.target.hasAttribute('open')) {
        const content = m.target.querySelector('.product-popup-modal__content-info');
        if (!content) return;

        const dataGender = m.target.getAttribute('data-gender');
        const genderTabs = m.target.querySelectorAll('.clear-this .half');
        for (const tab of genderTabs) {
          tab.classList.remove('active');
        }
        const activegender = m.target.querySelector(`.clear-this .half[data-id=${dataGender}-tab]`);
        activegender.click();

        if (!content.querySelector('size-guide-controller')) {
          const el = document.createElement('size-guide-controller');
          content.appendChild(el);
        }
      }
    }
  });
});

// Function to initialize size guides
function initializeSizeGuides() {
  // Initialize modal-based size guides
  document.querySelectorAll('.product-popup-modal').forEach(modal => {
    observer.observe(modal, { attributes: true });
  });
  
  // Initialize standalone size guides
  document.querySelectorAll('.Container.sizing').forEach(container => {
    if (!container.querySelector('size-guide-controller')) {
      const el = document.createElement('size-guide-controller');
      container.appendChild(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeSizeGuides);


